import actionCreatorFactory from 'typescript-fsa';

/** メッセージ情報 */
export interface IMessage {
	messageID: string;
	title: string;
	message: string;
	organizationID: string;
	status: string;
	messageType: string;
	startDateStr: string;
	contact: string;
	messageList: string[];
}

const actionCreator = actionCreatorFactory();

/** メッセージ一覧宛て名設定アクションクリエータ */
export const setOnesName = actionCreator<{
	onesName: string;
}>('SET_ONES_NAME');

/** メッセージ一覧設定アクションクリエータ */
export const setMessageList = actionCreator<{
	messages: IMessage[];
}>('SET_MESSAGE_LIST');

/** メッセージ一覧初期化アクションクリエータ */
export const clearMessageList = actionCreator<{}>('CLEAR_MESSAGE_LIST');



// WEBPACK FOOTER //
// ./src/actions/messageDetail.ts